export default __webpack_public_path__ + "static/media/incomplete_data_buttons.b8cce725.png";